<div class="logo-container">
  <img src="assets/images/connect-logo.svg" />
</div>
<div class="login-page-wrapper bms-theme full-height flex-space-between">
  <div class="login-form flex-column gap-24">
    <div class="flex-column">
      <span class="main-title">{{ 'AUTHENTICATION.LOGIN.WELCOME' | bmsTranslate }}</span>
      <span class="subtitle azure">{{ 'AUTHENTICATION.LOGIN.LOGIN_IN_VIA_AZURE' | bmsTranslate }}</span>
      @if (this.loggedOutAfterSessionExpired) {
        <span class="session-expired flex-start-center gap-2">
          <mat-icon class="icon-12" svgIcon="solid-error-circle-rounded"></mat-icon>
          {{ 'AUTHENTICATION.LOGIN.SESSION_EXPIRED_DESCRIPTION' | bmsTranslate }}</span
        >
      }
    </div>
    <div class="login-btn">
      <vdw-progress-button [canShowBMSTheme]="true" [fullWidth]="true" label="AUTHENTICATION.LOGIN.LOG_IN" [inProgress]="isLoggingIn" (progressClick)="login()"></vdw-progress-button>
    </div>
  </div>
  <app-connect-baseline class="baseline-visual"></app-connect-baseline>
</div>
